export default __webpack_public_path__ + "static/media/ay.542cb091.png";